// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import { store } from '@/store/store'
import leafletMapPlugin from './plugins/leafletMapPlugin'
import hashPlugin from './plugins/hashPlugin'
import paginationPlugin from './plugins/paginationPlugin'
import VueGtagPlugin from 'vue-gtag'
import VueTour from 'vue-tour'
import 'vue-tour/dist/vue-tour.css'

Vue.use(leafletMapPlugin)
Vue.use(hashPlugin)
Vue.use(paginationPlugin)
Vue.use(VueTour)

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueGtagPlugin, {
    config: { id: 'UA-38651806-3' }
  }, router)
}
Vue.config.productionTip = false

const filter = function (text, length, clamp) {
  clamp = clamp || '...'
  var node = document.createElement('div')
  node.innerHTML = text
  var content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}
Vue.filter('truncate', filter)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify,
  store: store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js